export const SUCCESS_CREATE = 'Успешно создано';
export const SUCCESS_DELETE = 'Успешно удалено';
export const SUCCESS_UPDATE = 'Успешно отредактировано';
export const SUCCESS_SYNC = 'Успешно синхранизировано';
export const SMTH_WENT_WRONG = 'Что-то пошло не так...';
export const CREATE_ERROR = 'Не удалось создать запись';
export const DELETE_ERROR = 'Не удалось удалить запись';
export const EDIT_ERROR = 'Не удалось отредактировать запись';
export const FETCH_ERROR = 'Не удалось загрузить данные';
export const REQUEST_LOADING = 'Запрос обрабатывается...';
export const FETCHING_STATUS = 'Загрузка данных...';
export const DELETE_CONFIRM = 'Вы точно хотите удалить эту запись ?';
export const SIGN_IN_TEXT = `Я, пользователь информационной системы "Payda", продолжая работу на интернет-ресурсе Payda, подтверждаю свое согласие, что несу ответственность за все осуществленные действия в соответствии с Законом РК от 7 января 2003 года №370 "Об электронном документе и электронной цифровой подписи".
Согласно статье №640 Кодекса РК об административных правонарушениях, незаконная передача закрытого ключа электронной цифровой подписи другим лицам влечет административную ответственность.`;
